import { SVGProps } from 'react';

/* eslint max-len: 0 */
export const MoreVertical = ( props: SVGProps<SVGSVGElement> ) => (
	<svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' { ...props }>
		<circle cx='12' cy='12' r='1.5' />
		<circle cx='12' cy='5' r='1.5' />
		<circle cx='12' cy='19' r='1.5' />
	</svg>
);
